module.exports = function() {
  return new Worker(__webpack_public_path__ + "formula.worker.06fb5731.worker.js");
};